import { APIWithoutURLBaseAndAuth as API } from './API';

const path = `municipios`;

const pathMunicipiosProjetos = `projetos/PROFESSORES/municipios`;

const pathRegioes = `projetos/PROFESSORES/regioes`;

const CidadeService = {
    list: async () => await API.list(`${process.env.REACT_APP_API_MUNICIPIOS_URL}/${path}`),
    filters: async filters => await API.filters(`${process.env.REACT_APP_API_MUNICIPIOS_URL}/${path}`, filters),
    
    filterRegions: async filters => await API.filters(`${process.env.REACT_APP_API_MUNICIPIOS_URL}/${path}/regioes`, filters),

    filterMuncipioRegiao: async filters => await API.filters(`${process.env.REACT_APP_API_MUNICIPIOS_URL}/${pathMunicipiosProjetos}`, filters),

    filterRegioes: async filters => await API.filters(`${process.env.REACT_APP_API_MUNICIPIOS_URL}/${pathRegioes}`, filters),

    findLocaisProvaObmepUltimosCincoAnos: async filters => await API.filters(`${process.env.REACT_APP_API_OBMEP_URL}/${path}/locais-prova-cinco-anos` , filters),
}

export default CidadeService;